import React from 'react'

interface WidgetTypeIconProps {
  code: string
  size?: number
  className?: string
}

const commonProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

const VideoEmbedIcon: React.FC<{ size: number; className?: string }> = ({ size, className }) => (
  <svg {...commonProps} width={size} height={size} className={className} aria-hidden="true">
    <rect x="2" y="4" width="20" height="16" rx="2" ry="2" />
    <polygon points="10 9 16 12 10 15 10 9" fill="currentColor" stroke="none" />
  </svg>
)

const EditorialIcon: React.FC<{ size: number; className?: string }> = ({ size, className }) => (
  <svg {...commonProps} width={size} height={size} className={className} aria-hidden="true">
    <line x1="21" y1="6"  x2="3" y2="6"  />
    <line x1="21" y1="12" x2="3" y2="12" />
    <line x1="17" y1="18" x2="3" y2="18" />
  </svg>
)

const BannerImageIcon: React.FC<{ size: number; className?: string }> = ({ size, className }) => (
  <svg {...commonProps} width={size} height={size} className={className} aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" stroke="none" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
)

const WidgetTypeIcon: React.FC<WidgetTypeIconProps> = ({ code, size = 16, className }) => {
  switch (code) {
    case 'video_embed':
      return <VideoEmbedIcon size={size} className={className} />
    case 'editorial':
      return <EditorialIcon size={size} className={className} />
    case 'banner_image':
      return <BannerImageIcon size={size} className={className} />
    default:
      return null
  }
}

export default WidgetTypeIcon
